
  import { computed, defineComponent } from 'vue';
  import { Colour } from '../../../helpers/colour';
  import './button.scss';

  /**
    * Button component
    * 
    * @example
    * <code>import TpxButton from '@manifesto-tech/tpximpact-design-system/components/atoms/button/button.vue'</code>
    */
  export default defineComponent({
    name: 'TpxButton',

    emits: [
      'click',
    ],

    props: {
      /**
        * Specify the background colour of the button
        */
      backgroundColour: {
        type: String,
        validator: (value: Colour) => {
          return Object.values(Colour).includes(value);
        },
      },

      /**
        * The text content of the button
        */
      content: {
        type: String,
      },

      /**
       * Is the button disabled?
       */
      isDisabled: {
        type: Boolean,
      },

      /**
       * Should we reduce down the padding of the button?
       * Possibly to accommodate larger icons
       */
      isNarrow: {
        type: Boolean,
      },

      /**
        * Specify the text colour of the button
        * @default 'currentColor'
        */
      textColour: {
        type: String,
        validator: (value: Colour) => {
          return Object.values(Colour).includes(value);
        },
      },

      /**
        * The button variant, such as `primary`, `secondary` or `icon`
        */
      variant: {
        type: String,
        validator: (value: string) => {
          return ['icon', 'primary', 'secondary'].includes(value);
        },
      },
    },
    
    data() {
      return {
        classes: computed(() => ({
          [`a-button--${this.variant}`]: !!this.variant,
          ['a-button--narrow']: this.isNarrow,
          [`bg--${Colour.White}`]: !!this.backgroundColour,
          [`text--${this.textColour}`]: !!this.textColour,
        })),
      };
    },
  });
